import routes from 'components/lab/constants/routes'

export type QuickLookupType = 'order' | 'account'

export const QUICK_LOOKUP_TYPES: Record<
  QuickLookupType,
  { label: string; getPath: (id: string) => string }
> = {
  order: {
    label: 'Order ID',
    getPath: (id) => `${routes.index}${routes.order.edit}${id}`,
  },
  account: {
    label: 'Account #',
    getPath: (id) => `${routes.index}${routes.patient.root}/${id}`,
  },
}
